export default {
  "root": "_root_8tz8n_1",
  "icon": "_icon_8tz8n_1",
  "content": "_content_8tz8n_1",
  "--rounded-corners": "_--rounded-corners_8tz8n_1",
  "--size-small": "_--size-small_8tz8n_1",
  "--size-medium": "_--size-medium_8tz8n_1",
  "--size-large": "_--size-large_8tz8n_1",
  "--color-neutral": "_--color-neutral_8tz8n_1",
  "--selected": "_--selected_8tz8n_1",
  "--color-critical": "_--color-critical_8tz8n_1",
  "--color-primary": "_--color-primary_8tz8n_1",
  "--disabled": "_--disabled_8tz8n_1",
  "aligner": "_aligner_8tz8n_1",
  "--rounded-corners-true--m": "_--rounded-corners-true--m_8tz8n_1",
  "--rounded-corners-false--m": "_--rounded-corners-false--m_8tz8n_1",
  "--size-small--m": "_--size-small--m_8tz8n_1",
  "--size-medium--m": "_--size-medium--m_8tz8n_1",
  "--size-large--m": "_--size-large--m_8tz8n_1",
  "--rounded-corners-true--l": "_--rounded-corners-true--l_8tz8n_1",
  "--rounded-corners-false--l": "_--rounded-corners-false--l_8tz8n_1",
  "--size-small--l": "_--size-small--l_8tz8n_1",
  "--size-medium--l": "_--size-medium--l_8tz8n_1",
  "--size-large--l": "_--size-large--l_8tz8n_1",
  "--rounded-corners-true--xl": "_--rounded-corners-true--xl_8tz8n_1",
  "--rounded-corners-false--xl": "_--rounded-corners-false--xl_8tz8n_1",
  "--size-small--xl": "_--size-small--xl_8tz8n_1",
  "--size-medium--xl": "_--size-medium--xl_8tz8n_1",
  "--size-large--xl": "_--size-large--xl_8tz8n_1"
};import "ni:sha-256;_Zz7tQ9LZXdyeMbAfPEcLmTidZtWVwdbFi2nhy6uJAw";